export default function Marquee({ items, className = "", itemClassName = "" }) {
  const row = (key) => (
    <div key={key} className="flex shrink-0 items-center" aria-hidden={key === "b"}>
      {items.map((it, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span className={`font-serif italic whitespace-nowrap ${itemClassName}`}>{it}</span>
          <span className="mx-10 inline-block h-1.5 w-1.5 rounded-full bg-[#C29B38]/70" />
        </span>
      ))}
    </div>
  );
  return (
    <div className={`overflow-hidden ${className}`} data-testid="editorial-marquee">
      <div className="marquee-track flex w-max">
        {row("a")}
        {row("b")}
      </div>
    </div>
  );
}
